import { render, staticRenderFns } from "./v-modal.vue?vue&type=template&id=30a4eef2&"
import script from "./v-modal.vue?vue&type=script&lang=js&"
export * from "./v-modal.vue?vue&type=script&lang=js&"
import style0 from "./v-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports